import { render, staticRenderFns } from "./TreatmentDuration.vue?vue&type=template&id=a65ea858&scoped=true&lang=pug&"
import script from "./TreatmentDuration.vue?vue&type=script&lang=js&"
export * from "./TreatmentDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65ea858",
  null
  
)

export default component.exports